<template>
<el-breadcrumb separator="/" class="navbar">
    <el-breadcrumb-item :to="{ path: '/' }">
      首页
    </el-breadcrumb-item>
    <el-breadcrumb-item v-if="!$empty(list)" v-for="(item,index) in list" :key="index" :to="item.path">
        {{item.title}}
    </el-breadcrumb-item>
</el-breadcrumb>
</template>
<script>
    export default {
        name: 'Navbar',
        data() {
            return {
                navbar: [],
            }
        },
        methods: {
            getNavbar: function() {
                this.navbar = this.$route.matched;
            }
        },
        //计算属性
        computed: {
            list: function() {
                let router = this.navbar;
                let list = [];
                for (var i = 0; i < router.length; i++) {
                    if (router[i].path == '/' || router[i].path == '' || router[i].meta.defaultPage) {
                        continue;
                    }
                    let obj = {};
                    obj.title = router[i].meta.title;
                    obj.path = router[i].meta.navPath;
                    obj.name = router[i].name;
                    list.push(obj);
                }
                return list;
            }
        },
        //初始化数据钩子
        created: function() {},
        //渲染完毕之后调用
        updated: function() {},
        watch: {
            $route: {
                handler: 'getNavbar',
                immediate: true
            }
        }
    };
</script>

<style  scoped>
.navbar{     
    width: calc(100% - 15px);  
    height:30px;         
    line-height: 30px;
    display: inline-block;
    vertical-align: middle;
    padding-left:15px;
    border-bottom:1px solid #3f515e;
    background:#F2F6FC;
}    
</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue